import { ChangeDetectionStrategy, Component, input } from '@angular/core';

/**
 * De knop die een zoektocht naar gelijkaardige charts open- en dichtklapt (twee
 * personen), overal dezelfde: profiel-, kruis- en levenskruis-tegels in Basis,
 * de Cycles-rijen, poort-info en Locks & Keys. Een attribuut-component op een
 * gewone knop, zodat klikken, focus en de eigen klassen van de aanroeper blijven:
 *
 *   <button type="button" hdChartMatchToggle [open]="..." [tooltip]="..." (click)="...">
 */
@Component({
  selector: 'button[hdChartMatchToggle]',
  standalone: true,
  template: '<i class="fas fa-user-group" aria-hidden="true"></i>',
  styles: `
    :host {
      flex-shrink: 0;
      padding: 0 2px;
      border: none;
      border-radius: 4px;
      background: none;
      font-size: 12px;
      line-height: 1;
      color: var(--dark-lightest);
      cursor: pointer;
    }

    :host(:hover),
    :host(.is-open) {
      color: var(--primary);
    }

    :host(:focus-visible) {
      outline: 2px solid var(--amber, #e3a008);
      outline-offset: 1px;
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[class.is-open]': 'open()',
    '[attr.aria-expanded]': 'open()',
    '[attr.aria-label]': 'tooltip()',
    '[attr.title]': 'tooltip()',
  },
})
export class HdChartMatchToggleComponent {
  readonly open = input(false);
  readonly tooltip = input('');
}
